import CheckIcon from '@mui/icons-material/Check';
import { Link, MenuItem, Tooltip, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import _ from 'lodash';

import { useGetRoleForUserQuery } from '../../../../queries/rolesQuery';
import { userQuery } from '../../../../queries/userQuery';

import type { GetTeamsResponse } from '../../../../queries/teamQuery';
import type { FC, HTMLAttributes, PropsWithChildren } from 'react';

type TeamSwitcherMenuProps = HTMLAttributes<HTMLDivElement> & {
	team: GetTeamsResponse & { selected?: boolean };
	onClick: any;
};

const TeamSwitcherMenu: FC<PropsWithChildren<TeamSwitcherMenuProps>> = ({
	team = {} as GetTeamsResponse,
	onClick = _.noop,
}: TeamSwitcherMenuProps) => {
	const { data: currentUser } = useQuery(userQuery);
	const { data: currentRole } = useGetRoleForUserQuery(currentUser, team.id || '');

	if (!team) {
		return null;
	}

	return (
		<MenuItem
			data-testid="sideMenu-team-switch-menu-item"
			ts-variant="sideMenuPanelOption"
			className={team.selected ? 'is-active' : ''}
			onClick={onClick}
		>
			<Link ts-variant="sideMenuSwitcherTeamLink">
				<Tooltip title={team.name}>
					<Typography component="div" ts-variant="teamName">
						{team.name || ''}
					</Typography>
				</Tooltip>
				{currentRole && (
					<Typography component="div" ts-variant="roleName">
						{currentRole.label || ''}
					</Typography>
				)}
				{team.selected && <CheckIcon ts-variant="teamSwitcherCheckIcon" />}
			</Link>
		</MenuItem>
	);
};

export default TeamSwitcherMenu;
